export default __webpack_public_path__ + "static/media/show_green_button_pressed_icon.73c68b69.png";